export const isCreditError = (error: string): boolean => /credit|recharge/i.test(error);

const RETRYABLE_PATTERN =
  /timeout|network error|failed to fetch|ECONNREFUSED|ENOTFOUND|ETIMEDOUT|temporarily unavailable|503|504|gateway/i;

export const isRetryableError = (error: string): boolean => {
  if (isCreditError(error)) return false;

  return RETRYABLE_PATTERN.test(error);
};
